import {
    ODataHeader,
    ODataString,
    ODataBoolean,
    ODataDate
} from "pbas-vue-components";
import { translate2 } from "../trans2";

const TagsHeaders = [
    new ODataHeader({
        title: "ID",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.description",
        type: new ODataString("Description"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.plans",
        type: new ODataString("Plans[]/Name", {
            getHtml: (item, type) => {
                return (
                    "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
                    type.getString(item, type) +
                    "</div>"
                );
            }
        }),
        sortable: false,
        visible: false,
        searchable: true,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.plans",
        sortable: false,
        type: new ODataString("Plans[]/Translations[]/Name", {
          getString: (item) => {
            var res = "";
            if (item.Plans) {
              res = item.Plans.map((u) => translate2(u, "Name")).join(", ");
            }
            return res;
          },
          getHtml: (item, type) => {
            if (item.Plans) {
              return (
                "<div style='word-wrap: break-word; white-space: pre-wrap;'><span style='word-wrap: normal; white-space: nowrap; max-width: 200px'>" +
                item.Plans.map((u) => translate2(u, "Name")).join(
                  "</span>, <span style='word-wrap: normal; white-space: nowrap'>"
                ) +
                "</span></div>"
              );
            }
            return "";
          },
        }),
      }),
      new ODataHeader({
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        type: new ODataString("Plans[]/Translations[]/LanguageCode"),
      }),
    new ODataHeader({
        title: "Plans",
        type: new ODataString("Plans/Id"),
        sortable: false,
        visible: false,
        searchable: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "Plans",
        type: new ODataString("Plans/UniqueIdentifier"),
        sortable: false,
        visible: false,
        searchable: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "globals.broker",
        type: new ODataString("Broker/Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "Broker",
        type: new ODataString("Broker/Id"),
        sortable: false,
        visible: false,
        searchable: true,
        allowVisibilityChange: false
    })
];

export default TagsHeaders;